import React, {Component} from 'react'
import styled from "styled-components"
import {createSettlementProviderSelection} from "manager/redux/referral"
import {createStructuredSelector} from "reselect"
import {selectSearchConfig, selectSearchNameFilter} from "manager/selectors/settlement_provider_search_selectors"
import {connect} from "react-redux"
import {
  selectAgentOpId,
  selectAssignmentTransactionHash,
  selectTransactionOpId
} from "manager/selectors/referral_selectors"
import {SettlementCard} from "manager/views/components/Settlement/Common/SettlementCard"
import searchImage from "manager/../images/search.png"
import {DESKTOP_BREAKPOINT} from "manager/views/components/Settlement/constants"
import {segmentEventTracker} from "common/analytics"

const NoResultContainer = styled(SettlementCard)`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const SearchImage = styled.div`
  background-size: contain;
  background-image: url(${searchImage});
  background-repeat: no-repeat;
  height: 96px;
  width: 116px;
  margin: 10px 0px;
`

const TextDiv = styled.div`
  color: #8C8C8C;
  font-weight: bold;
  text-align: center;
  margin-bottom: 30px;
  
  width: 280px;
  br {
    display: none;
  }
  @media screen and ${DESKTOP_BREAKPOINT} {
    width: auto;
    br {
      display: inline;
    }
  }
`

const WithSearchTextDiv = styled(TextDiv)`
  margin-top:20px;
`

const SelectA = styled.a`
  font-weight: 300;
  text-align: center;
  margin-bottom: 20px;
`

class NoQualiaMatch extends Component {

  selectNonQualiaProvider = () => {
    const {dispatch, hash, nameFilter, searchConfig, transaction_op_id, agent_op_id} = this.props
    dispatch(createSettlementProviderSelection(hash, nameFilter, {...searchConfig}))
    segmentEventTracker('None-Qualia-Provider Selected', {'transaction_op_id': transaction_op_id, 'agent_op_id': agent_op_id})
  }

  render() {
    const {nameFilter} = this.props
    return (
      <NoResultContainer>
        {!nameFilter && <SearchImage/>}
        {!nameFilter && <TextDiv>We couldn’t find any local providers in this area. <br/> Try entering a provider name or use a different address.</TextDiv>}
        {nameFilter && <WithSearchTextDiv>This provider doesn't integrate with our digital closing experience, powered by Qualia.</WithSearchTextDiv>}
        {nameFilter && <SelectA onClick={this.selectNonQualiaProvider}>Select {nameFilter} to continue</SelectA>}
      </NoResultContainer>
    )
  }

}

const selector = createStructuredSelector({
  hash: selectAssignmentTransactionHash,
  nameFilter: selectSearchNameFilter,
  searchConfig: selectSearchConfig,
  transaction_op_id: selectTransactionOpId,
  agent_op_id: selectAgentOpId,
})

export default connect(selector)(NoQualiaMatch)
